<template>
  <div>
    <div class="not-found-logo"></div>

    <div class="not-found-text">
      <p>{{ $tr('notFoundPage.sorry') }}</p>
      <p>{{ $tr('notFoundPage.wayOut') }}</p>
    </div>

    <div class="not-found-controls">
      <input class="vcv-button" type="submit" :value="$tr('notFoundPage.goToHome')" @click="click" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'not-found',

  computed: {
    defaultPathName() {
      return this.$store.state.path.defaultPathName;
    }
  },

  methods: {
    click() {
      this.$router.push({ name: this.defaultPathName });
    }
  }
};
</script>

<style lang="scss" scoped>
// why i can not change .content-wrapper margin?

// .content class is added automaticaly from App.vue
.content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 100px;

  .not-found-logo {
    min-height: 219px;
    min-width: 537px;
    background-image: url('/static/images/elements/404.png');
    background-repeat: no-repeat;
  }

  .not-found-text {
    padding-top: 72px;
    padding-bottom: 32px;
    text-align: center;
    font-size: 22px;

    p {
      margin: 0px;
    }
  }

  .not-found-controls {
    .vcv-button {
      min-width: 230px;
    }
  }
}
</style>
